/**
 * LoginComponentV2.js
 * BS4 modal which houses login.js component and
 * signup.js component as tabs.
 * @author Jaiwardhan Swarnakar
 */
import React from 'react';
import BaseComponent from '../../BaseComponent';
import LocUtils from "../../../util/localization/LocUtils";

class GoogleSSOSpeechBubble extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div
                style={{
                    maxWidth: "600px",
                    margin: "40px auto",
                    padding: "10px",
                    display: "flex",
                    position: "absolute",
                    justifyContent: "center",
                    bottom: "70%",
                    right: "33%"
                }}
            >
                {/* Speech Bubble Container */}
                <div
                    style={{
                        backgroundColor: "#fff5dc",
                        border: "5px solid #f3e2a9",
                        borderRadius: "20px",
                        padding: "16px",
                        position: "relative",
                        color: "#5b3700",
                        fontFamily: "Comic Sans MS, cursive, sans-serif",
                        fontSize: "16px",
                        lineHeight: "1.4",
                        boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                        display: "flex",
                        alignItems: "center",
                        gap: "16px",
                    }}
                >
                    {/* Character Avatar Inside Bubble */}
                    <div
                        style={{
                            width: "80px",
                            height: "80px",
                            borderRadius: "50%",
                            overflow: "hidden",
                            border: "4px solid #f3e2a9",
                            flexShrink: 0,
                        }}
                    >
                        <img
                            alt=""
                            src={process.env.REACT_APP_ASSET_PATH + "/dialogs/permanentBenefits/marie_npc.png"}
                            style={{width: "100%", height: "100%", objectFit: "cover"}}
                        />
                    </div>

                    {/* Bubble Text */}
                    <div>
                        <strong style={{color: "#f0b400", fontSize: "18px"}}>
                            {this.props.showGoogleLoginDetails ? LocUtils.TPure("dialogs.GoogleSSO.googleSSOSpeechBubble.googleSSOShowBlobDetailsHeader") :
                                LocUtils.TPure("dialogs.GoogleSSO.googleSSOSpeechBubble.googleSSOSpeechBubbleHeader")}
                        </strong>
                        <br/>
                        {this.props.showGoogleLoginDetails ? LocUtils.TPure("dialogs.GoogleSSO.googleSSOSpeechBubble.googleSSOShowBlobDetailsBody") :
                            LocUtils.TPure("dialogs.GoogleSSO.googleSSOSpeechBubble.googleSSOSpeechBubbleBody")}
                    </div>

                    {/* Bubble Tail */}
                    <div
                        style={{
                            position: "absolute",
                            bottom: "-12px",
                            left: "450px",
                            width: 0,
                            height: 0,
                            borderLeft: "12px solid transparent",
                            borderRight: "12px solid transparent",
                            borderTop: "12px solid #fff5dc",
                        }}
                    />
                </div>
            </div>
        );
    }
}


export default GoogleSSOSpeechBubble;